import { createRouter, createWebHashHistory } from 'vue-router';

import DemandeIndivShow from '../pages/admin/demande/DemandeIndivShow.vue';
import DemandeAlumniIndex from '../pages/admin/demande/DemandeAlumniIndex.vue';
import UserIndex from '../pages/admin/users/UserIndex.vue';
import UserCreate from '../pages/admin/users/UserCreate.vue';
import UserEdit from '../pages/admin/users/UserEdit.vue';
import UserHome from '../pages/admin/users/UserHome.vue';
import AdminLayout from '../layouts/AdminLayout.vue';

const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: '/',
            component: AdminLayout,
            children: [
                {
                    path: '/demande',
                    name: 'DemandeAlumniIndex',
                    alias: '/admin',
                    component: DemandeAlumniIndex,
                    meta: {
                        breadcrumb: [{ text: 'Demandes Alumni' }]
                    }
                },
                {
                    path: '/demande-indiv/:id',
                    name: 'DemandeIndivShow',
                    component: DemandeIndivShow,
                    props: true,
                    meta: {
                        breadcrumb: [
                            { text: 'Demandes Alumni', name: 'DemandeAlumniIndex' },
                            { text: 'Détail de la demande' }
                        ]
                    }
                },
                {
                    path: 'users',
                    name: 'UserIndex',
                    component: UserIndex,
                    meta: {
                        breadcrumb: [{ text: 'Utilisateurs' }]
                    }
                },
                {
                    path: 'users/create',
                    name: 'UserCreate',
                    component: UserCreate,
                    meta: {
                        breadcrumb: [
                            { text: 'Utilisateurs', name: 'UserIndex' },
                            { text: 'Nouvel utilisateur' }
                        ]
                    }
                },
                {
                    path: 'users/edit/:userId',
                    name: 'UserEdit',
                    component: UserEdit,
                    meta: {
                        breadcrumb: [
                            { text: 'Utilisateurs', name: 'UserIndex' },
                            { text: 'Modifier un utilisateur' }
                        ]
                    }
                },
                {
                    path: 'users/home',
                    name: 'UserHome',
                    component: UserHome,
                    meta: {
                        breadcrumb: [
                            { text: 'Utilisateurs', name: 'UserIndex' },
                            { text: 'Mon profil' }
                        ]
                    }
                }
            ]
        },
        {
            path: '/:pathMatch(.*)*',
            redirect: { name: 'DemandeAlumniIndex' }
        }
    ]
});

export default router;
